export function Quality() {
  return (
    <section id="quality" className="section_quality">
      <div className="padding-vertical padding-huge">
        <div className="container-full">
          <div className="content_quality">
            <div className="quality_image-wrapper">
              <div
                data-motion-id="78959cb6-d57e-81c9-073b-8e3d840056b2"
                className="platforms_image editorial-frame editorial-frame--sage"
              >
                <div
                  data-motion-id="a96d7a30-ad6a-751d-a678-e49a064cc942"
                  className="image_shading"
                ></div>
                <div
                  data-motion-id="4b749ea9-88f0-0432-1e76-5388c2381e36"
                  className="image_shading is-green"
                ></div>
                <img
                  src="/assets/images/editorial/weathered-stone-512.webp"
                  srcSet="/assets/images/editorial/weathered-stone-256.webp 256w, /assets/images/editorial/weathered-stone-512.webp 512w, /assets/images/editorial/weathered-stone-768.webp 768w"
                  sizes="(max-width: 479px) calc((100vw - 48px) / 2), 200px"
                  width="1254"
                  height="1254"
                  loading="lazy"
                  decoding="async"
                  alt="Illustrative weathered limestone and grass"
                  className="editorial-image"
                />
                <div className="icon-position_center">
                  <div className="icon-embed-medium text-color-primary25 w-embed">
                    <svg
                      aria-hidden="true"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0 40.0005V0.000488281H40V40.0005H0ZM2.45902 9.34475H9.34426V2.45951H2.45902V9.34475ZM11.8579 9.34475H18.7432V2.45951H11.8579V9.34475ZM21.2022 9.34475H28.0874V2.45951H21.2022V9.34475ZM30.6011 9.34475H37.541V2.45951H30.6011V9.34475ZM2.45902 18.7437H9.34426V11.8584H2.45902V18.7437ZM11.8579 18.7437H18.7432V11.8584H11.8579V18.7437ZM21.2022 18.7437H28.0874V11.8584H21.2022V18.7437ZM30.6011 18.7437H37.541V11.8584H30.6011V18.7437ZM2.45902 28.0879H9.34426V21.2027H2.45902V28.0879ZM11.8579 28.0879H18.7432V21.2027H11.8579V28.0879ZM21.2022 28.0879H28.0874V21.2027H21.2022V28.0879ZM30.6011 28.0879H37.541V21.2027H30.6011V28.0879ZM2.45902 37.5415H9.34426V30.5469H2.45902V37.5415ZM11.8579 37.5415H18.7432V30.5469H11.8579V37.5415ZM21.2022 37.5415H28.0874V30.5469H21.2022V37.5415ZM30.6011 37.5415H37.541V30.5469H30.6011V37.5415Z"
                        fill="currentColor"
                      ></path>
                      <rect
                        x="0.832031"
                        y="29.167"
                        width="10"
                        height="10"
                        fill="currentColor"
                      ></rect>
                      <rect x="20" y="10.0005" width="10" height="10" fill="currentColor"></rect>
                      <rect
                        x="0.832031"
                        y="0.833984"
                        width="10"
                        height="10"
                        fill="currentColor"
                      ></rect>
                      <rect x="29.168" y="29.167" width="10" height="10" fill="currentColor"></rect>
                    </svg>
                  </div>
                </div>
              </div>
              <div
                data-motion-id="5482d63d-9e65-4b00-7d44-e839c31d1a99"
                className="platforms_image editorial-frame editorial-frame--sage"
              >
                <div
                  data-motion-id="9cf7bdeb-a8e6-d77f-a13a-e5f6bb7fafe1"
                  className="image_shading"
                ></div>
                <div
                  data-motion-id="a58e1068-6856-812a-b4e8-e6badb8e181e"
                  className="image_shading is-green"
                ></div>
                <img
                  src="/assets/images/editorial/stream-edge-512.webp"
                  srcSet="/assets/images/editorial/stream-edge-256.webp 256w, /assets/images/editorial/stream-edge-512.webp 512w, /assets/images/editorial/stream-edge-768.webp 768w"
                  sizes="(max-width: 479px) calc((100vw - 48px) / 2), 200px"
                  width="1254"
                  height="1254"
                  loading="lazy"
                  decoding="async"
                  alt="Illustrative shallow stream with pebbles"
                  className="editorial-image"
                />
              </div>
              <img src="/assets/images/Grid_1.svg" loading="lazy" alt="" className="bg-grid1" />
            </div>
            <div data-word-reveal="true" className="quality_wrapper">
              <h2 data-word-reveal="true" className="heading-xsmall heading-inline section-prose">
                From design choices to testable questions.
              </h2>
              <div className="swiss_flag-wrapper">
                <img
                  src="/assets/images/CH_Flag.svg"
                  loading="lazy"
                  data-motion-id="412fbdbd-9651-c31c-0f75-035e2f30a196"
                  alt="Swiss Flag"
                  className="swiss_flag"
                />
              </div>
              <p data-word-reveal="true" className="heading-xsmall heading-inline section-prose">
                We examine how hardware, software and component interfaces affect a system’s
                behaviour, maintenance and evaluation.
              </p>
            </div>
            <div className="quality_image-wrapper is-right">
              <div
                data-motion-id="eae23e5e-4fda-6040-39d8-9a7952d11cbb"
                className="rectangle_image-wrapper editorial-frame editorial-frame--sand"
              >
                <div
                  data-motion-id="f2b3c786-e8b6-35a8-e32a-f59cb6dd33fc"
                  className="image_shading"
                ></div>
                <div
                  data-motion-id="532de25b-2f2e-0a52-a8a8-76feaef4dec0"
                  className="image_shading is-beige"
                ></div>
                <img
                  src="/assets/images/editorial/field-meadow-960.webp"
                  srcSet="/assets/images/editorial/field-meadow-480.webp 480w, /assets/images/editorial/field-meadow-960.webp 960w, /assets/images/editorial/field-meadow-1440.webp 1440w"
                  sizes="(max-width: 479px) calc(100vw - 32px), 400px"
                  width="1536"
                  height="1024"
                  loading="lazy"
                  decoding="async"
                  alt="Illustrative alpine meadow under an overcast sky"
                  className="rectangle_image editorial-image"
                />
                <div className="icon-position_top-right">
                  <div className="icon-embed-medium text-color-primary25 w-embed">
                    <svg
                      aria-hidden="true"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0 40.0005V0.000488281H40V40.0005H0ZM2.45902 9.34475H9.34426V2.45951H2.45902V9.34475ZM11.8579 9.34475H18.7432V2.45951H11.8579V9.34475ZM21.2022 9.34475H28.0874V2.45951H21.2022V9.34475ZM30.6011 9.34475H37.541V2.45951H30.6011V9.34475ZM2.45902 18.7437H9.34426V11.8584H2.45902V18.7437ZM11.8579 18.7437H18.7432V11.8584H11.8579V18.7437ZM21.2022 18.7437H28.0874V11.8584H21.2022V18.7437ZM30.6011 18.7437H37.541V11.8584H30.6011V18.7437ZM2.45902 28.0879H9.34426V21.2027H2.45902V28.0879ZM11.8579 28.0879H18.7432V21.2027H11.8579V28.0879ZM21.2022 28.0879H28.0874V21.2027H21.2022V28.0879ZM30.6011 28.0879H37.541V21.2027H30.6011V28.0879ZM2.45902 37.5415H9.34426V30.5469H2.45902V37.5415ZM11.8579 37.5415H18.7432V30.5469H11.8579V37.5415ZM21.2022 37.5415H28.0874V30.5469H21.2022V37.5415ZM30.6011 37.5415H37.541V30.5469H30.6011V37.5415Z"
                        fill="currentColor"
                      ></path>
                      <path
                        d="M1.11111 1.1116H10V10.0005H1.11111V1.1116Z"
                        fill="currentColor"
                      ></path>
                      <path
                        d="M10.5556 10.556H19.4444V19.4449H10.5556V10.556Z"
                        fill="currentColor"
                      ></path>
                      <path d="M20 20.0005H28.8889V28.8894H20V20.0005Z" fill="currentColor"></path>
                      <path
                        d="M29.4444 29.4449H38.3333V38.3338H29.4444V29.4449Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </div>
                </div>
              </div>
              <span className="editorial-image-caption">Illustrative imagery</span>
              <img src="/assets/images/Grid_2.svg" loading="lazy" alt="" className="bg-grid2" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
